module.exports = __webpack_public_path__ + "_assets/img/LimitedTimeMission-Stpes-Detail-Title.7611b18a.svg";